// import React, { useState } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   CardMedia,
//   Chip,
//   Divider,
//   Grid,
//   Typography,
//   useTheme,
//   Stack,
// } from "@mui/material";
// import ImageSlideshow from "../../components/ImageSlideShow";
// import { ZoomInRounded } from "@mui/icons-material";
// import TransitionsModal from "../../components/modal/modal";
// import ImageSlider from "../../components/ImageSlider";
// import ContentLayout from "../../components/ContentLayout";
// import VisionInternationalImg from "../../static_data/student_corner/Study_Abroad/VISION_INTERNATIONAL.json";
// import CareerCounsellingSeminarImg from "../../static_data/student_corner/Study_Abroad/CAREER_COUNSELLING_SEMINAR.json";
// import PhysioactiveClinicImg from "../../static_data/student_corner/Campus_Interviews/Campus_Interviews.json";
// import Scholarship_for_Abroad_Education from "../../static_data/student_corner/Study_Abroad/SCHOLARSHIP_FOR_ABROAD_EDUCATION.json";
// import GSGlobalAcademy from "../../static_data/student_corner/Study_Abroad/GS_Global_Academy.json";
// import MBPatilEdu from "../../static_data/student_corner/Study_Abroad/MBPATILedu.json";
// import CareerCounsellingSeminar_ProfessionalPathways from "../../static_data/student_corner/Study_Abroad/CareerCounsellingSeminar_ProfessionalPathways.json";



// // Define missing types
// type CurricularEventObject = {
//   title?: string;
//   img?: Array<ImageType>;
//   date?: string;
//   description?: string;
// };

// type EventsProps = {
//   data: Array<CurricularEventObject>;
// };

// type ImageType = {
//   src: string;
//   alt: string;
// };

// type Years = Array<DataItem>;

// type DataItem = {
//   title: string;
// };

// const years: Years = [
//   { title: "Campus Interviews" },
//   { title: "Study Abroad" },
//   { title: "Placement Cell Annual Reports" },
// ];

// const studyAbroadEvents: Array<CurricularEventObject> = [
//   {
//     title: "Career Counseling Session",
//     img: CareerCounsellingSeminar_ProfessionalPathways.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/CareerCounsellingSeminar_ProfessionalPathways/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "09/17/2025",
//   },
//   {
//     title: "Overseas education: M B Patil Education",
//     img: MBPatilEdu.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/Study abroad-MB PATIL Education/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "08/23/2025",
//   },
//   {
//     title: "GS Global Academy's Study Abroad Session ",
//     img: GSGlobalAcademy.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/GS_Global_Academy/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "06/14/2025",
//   },
//   {
//     title: "Seminar on Scholarship for Abroad Education",
//     img: Scholarship_for_Abroad_Education.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/SCHOLARSHIP_FOR_ABROAD_EDUCATION/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "11/04/2025",
//   },
//   {
//     title: "Vision International",
//     img: VisionInternationalImg.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/VISION_INTERNATIONAL/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "10/12/2024",
//   },
//   {
//     title: "Career Counselling Seminar",
//     img: CareerCounsellingSeminarImg.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Study_Abroad/CAREER_COUNSELLING_SEMINAR/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "01/27/2025",
//   },
// ];

// const campusInterviewsEvents: Array<CurricularEventObject> = [
//   {
//     title: "Physioactive Clinic",
//     img: PhysioactiveClinicImg.images.map((image) => ({
//       src: require(`../../assets/images/student_corner/Campus_Interviews/PHYSIOACTIVE_CLINIC/${image.src.split('/').pop()}`),
//       alt: image.title,
//     })),
//     date: "01/30/2025",
//   },
// ];

// const placementCellAnnualReports: Array<CurricularEventObject> = [

// ];

// const RenderEvent = ({ data }: EventsProps) => {
//   const theme = useTheme();
//   const [open, setOpen] = useState(false);
//   const [title, setTitle] = useState("");
//   const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

//   return (
//     <Grid container spacing={2}>
//       {data?.map((item: CurricularEventObject, index: number) => {
//         const isMultiImages = Array.isArray(item?.img) && item?.img?.length > 1;
//         const imageToShow = (item?.img ? item?.img[0]?.src : "") as string;
//         return (
//           <Grid
//             key={index}
//             item
//             xs={12}
//             sm={6}
//             p={2}
//             margin={"auto"}
//             flexWrap={"wrap"}
//             sx={{
//               minWidth: {
//                 xs: "100%",
//                 sm: "48%",
//               },
//               maxWidth: {
//                 xs: "100%",
//                 sm: "48%",
//               },
//             }}
//           >
//             <Card
//               sx={{
//                 alignContent: "space-between",
//                 minWidth: "100%",
//                 maxWidth: "100%",
//                 minHeight: "400px",
//                 maxHeight: "400px",
//                 position: "relative",
//               }}
//             >
//               {
//                 <>
//                   {isMultiImages ? (
//                     <Box sx={{ position: "relative" }}>
//                       <ImageSlideshow
//                         sx={{}}
//                         images={item?.img as Array<ImageType>}
//                         showCaption={false}
//                       />
//                       <Box
//                         sx={{
//                           position: "absolute" as "absolute",
//                           top: "50%",
//                           left: "50%",
//                           transform: "translate(-50%, -50%)",
//                         }}
//                         onClick={() => {
//                           setTitle(item?.title ?? "");
//                           setSliderImages(item?.img);
//                           setOpen(true);
//                         }}
//                       >
//                         <ZoomInRounded
//                           sx={{
//                             color: "#fdd025",
//                             zIndex: 99,
//                             fontSize: "4rem",
//                             "&:hover": {
//                               fontSize: "6rem",
//                             },
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   ) : (
//                     <Box sx={{ position: "relative" }}>
//                       <CardMedia
//                         component="img"
//                         height="240px"
//                         sx={{
//                           pt: 1,
//                           margin: "auto",
//                           objectFit: "cover",
//                         }}
//                         image={imageToShow}
//                         alt={item?.title as string}
//                       />
//                       <Box
//                         sx={{
//                           position: "absolute" as "absolute",
//                           top: "50%",
//                           left: "50%",
//                           transform: "translate(-50%, -50%)",
//                         }}
//                         onClick={() => {
//                           setTitle(item?.title ?? "");
//                           setSliderImages(item?.img);
//                           setOpen(true);
//                         }}
//                       >
//                         <ZoomInRounded
//                           sx={{
//                             color: "#fdd025",
//                             zIndex: 2,
//                             fontSize: "4rem",
//                             "&:hover": {
//                               fontSize: "6rem",
//                             },
//                           }}
//                         />
//                       </Box>
//                     </Box>
//                   )}
//                   <Divider sx={{ py: 1 }} />
//                 </>
//               }
//               <CardContent>
//                 <Box sx={{ textAlign: "center" }}>
//                   <Typography
//                     variant="h5"
//                     sx={{
//                       fontWeight: "bold",
//                       color: theme.palette.primary.contrastText,
//                       padding: "10px", // Added padding
//                     }}
//                   >
//                     {item?.title}
//                   </Typography>
//                   {item?.description && (
//                     <Typography
//                       variant="subtitle1"
//                       sx={{
//                         textAlign: "left",
//                         fontWeight: "bold",
//                         fontSize: "1rem",
//                         color: theme.palette.grey[900],
//                         p: 2,
//                       }}
//                     >
//                       {item?.description}
//                     </Typography>
//                   )}
//                 </Box>
//               </CardContent>
//               <Typography
//                 sx={{
//                   color: "black",
//                   position: "absolute",
//                   bottom: 16,
//                   left: "50%",
//                   transform: "translateX(-50%)",
//                 }}
//               >
//                 {formatDate(item?.date as string)}
//               </Typography>
//             </Card>
//           </Grid>
//         );
//       })}




//       {data?.length === 0 && <Box sx={{ p: 4 }}>No Data</Box>}
//       {sliderImages && (
//         <TransitionsModal
//           open={open}
//           setOpen={setOpen}
//           title={title}
//           children={
//             <Grid item xs={12} margin={"auto"}>
//               <Box sx={{ width: "75%", margin: "auto" }}>
//                 <ImageSlider images={sliderImages} />
//               </Box>
//             </Grid>
//           }
//         />
//       )}
//     </Grid>
//   );
// };

// // Define or import the formatDate function
// const formatDate = (dateString: string) => {
//   const options: Intl.DateTimeFormatOptions = { year: 'numeric', month: 'long', day: 'numeric' };
//   return new Date(dateString).toLocaleDateString(undefined, options);
// };

// const Placement = () => {
//   const [title, setTitle] = useState("Campus Interviews");

//   const YearTabs = () => (
//     <Grid container spacing={2}>
//       {years?.map((item) => (
//         <Grid item key={item?.title} xs="auto" sx={{ my: { sm: 1, md: 4 } }}>
//           <Chip
//             label={item?.title}
//             variant="filled"
//             sx={{
//               color: item?.title === title ? "secondary.main" : "white",
//               backgroundColor:
//                 item?.title === title ? "transparent" : "secondary.main",
//               cursor: "pointer",
//               border: "2px solid",
//               padding: "8px 16px",
//               borderRadius: "16px",
//               textTransform: "uppercase",
//               fontWeight: "bold",
//               transition: "all 0.3s ease-in-out",
//               "&:hover": {
//                 opacity: 0.8,
//                 color: "inherit",
//                 backgroundColor: "transparent",
//                 border: "2px solid",
//                 borderColor: "secondary.main",
//                 "& .MuiChip-label": {
//                   textDecoration: "underline",
//                 },
//               },
//               "&:active": {
//                 transform: "scale(0.95)",
//               },
//             }}
//             onClick={() => setTitle(item?.title ?? "")}
//           />
//         </Grid>
//       ))}
//     </Grid>
//   );

//   const filteredEvents = title === "Campus Interviews" ? campusInterviewsEvents : (title === "Placement Cell Annual Reports" ? placementCellAnnualReports : studyAbroadEvents);

//   return (
//     <Box
//       sx={{
//         backgroundColor: "primary.light",
//         p: { xs: 1, md: 3 },
//         width: "90%",
//         margin: "auto",
//       }}
//     >
//       <Stack
//         direction="column"
//         alignItems="center"
//         justifyContent="center"
//         sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
//       >
//         <Typography
//           fontSize={16}
//           sx={{ textIndent: 32, m: 1, mt: { xs: 3, md: 1 } }}
//         >
//           The Placement Cell at PES Modern College of Physiotherapy is dedicated
//           to bridging the gap between academia and the professional world. Our
//           primary objective is to facilitate the successful transition of our
//           students into rewarding careers. The cell plays a pivotal role in
//           guiding students towards their desired career paths, providing
//           comprehensive support and resources.
//         </Typography>
//         <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
//           The placement cell actively engages in building strong industry
//           relationships, identifying potential employers, and creating ample
//           opportunities for students. We organize career counselling sessions,
//           workshops, and seminars to equip students with essential soft skills,
//           communication skills, and interview techniques. Mock interviews are
//           conducted to boost students’ confidence and prepare them for
//           real-world challenges.
//         </Typography>
//         <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
//           The cell maintains an up-to-date database of students, their academic
//           performance, and career aspirations. This information is shared with
//           prospective employers to match suitable candidates with appropriate
//           job profiles. We organize on-campus recruitment drives, inviting a
//           diverse range of healthcare organizations to conduct interviews and
//           select eligible students.
//         </Typography>
//         <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
//           Beyond placements, the cell provides continuous support to students in
//           exploring higher education options, such as master’s programs or
//           doctoral studies. We offer guidance on entrance exams, application
//           processes, and potential research areas. Our aim is to empower
//           students to make informed decisions about their future career paths.
//         </Typography>
//         <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
//           The placement cell also functions as a bridge between alumni and the
//           college. We organize alumni interactions, mentorship programs, and
//           networking events to provide current students with valuable insights
//           and industry perspectives. By fostering strong alumni connections, we
//           create a supportive network for our graduates.
//         </Typography>
//         <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
//           The placement cell at Modern College of Physiotherapy is committed to
//           the overall success of our students. We strive to create a conducive
//           environment that empowers them to achieve their career goals and make
//           significant contributions to the field of physiotherapy.
//         </Typography>

//         <YearTabs />
//         <RenderEvent data={filteredEvents} />
//       </Stack>
//     </Box>
//   );
// };

// export default Placement;




import React, { useState } from "react";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
  Grid,
  Typography,
  useTheme,
  Stack,
  Button,
} from "@mui/material";
import ImageSlideshow from "../../components/ImageSlideShow";
import { ZoomInRounded, PictureAsPdf } from "@mui/icons-material";
import TransitionsModal from "../../components/modal/modal";
import ImageSlider from "../../components/ImageSlider";
import ContentLayout from "../../components/ContentLayout";
import VisionInternationalImg from "../../static_data/student_corner/Study_Abroad/VISION_INTERNATIONAL.json";
import CareerCounsellingSeminarImg from "../../static_data/student_corner/Study_Abroad/CAREER_COUNSELLING_SEMINAR.json";
import PhysioactiveClinicImg from "../../static_data/student_corner/Campus_Interviews/Campus_Interviews.json";
import Scholarship_for_Abroad_Education from "../../static_data/student_corner/Study_Abroad/SCHOLARSHIP_FOR_ABROAD_EDUCATION.json";
import GSGlobalAcademy from "../../static_data/student_corner/Study_Abroad/GS_Global_Academy.json";
import MBPatilEdu from "../../static_data/student_corner/Study_Abroad/MBPATILedu.json";
import CareerCounsellingSeminar_ProfessionalPathways from "../../static_data/student_corner/Study_Abroad/CareerCounsellingSeminar_ProfessionalPathways.json";

import STUDYABROADAWARENESS from "../../static_data/student_corner/Study_Abroad/STUDYABROADAWARENESS.json";

// ---------------- TYPES ----------------

type CurricularEventObject = {
  title?: string;
  img?: Array<ImageType>;
  date?: string;
  description?: string;
};

type EventsProps = {
  data: Array<CurricularEventObject>;
};

type ImageType = {
  src: string;
  alt: string;
  type?: "image" | "pdf"; // 👈 added
};

type Years = Array<DataItem>;

type DataItem = {
  title: string;
};

// ---------------- DATA ----------------

const years: Years = [
  { title: "Campus Interviews" },
  { title: "Study Abroad" },
  { title: "Placement Cell Annual Reports" },
];

const studyAbroadEvents: Array<CurricularEventObject> = [
    {
    title: "STUDY ABROAD AWARENESS",
    img: STUDYABROADAWARENESS.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/STUDYABROADAWARENESS/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "08/08/2026",
  },
  {
    title: "Career Counseling Session",
    img: CareerCounsellingSeminar_ProfessionalPathways.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/CareerCounsellingSeminar_ProfessionalPathways/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "09/17/2025",
  },
  {
    title: "Overseas education: M B Patil Education",
    img: MBPatilEdu.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/Study abroad-MB PATIL Education/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "08/23/2025",
  },
  {
    title: "GS Global Academy's Study Abroad Session ",
    img: GSGlobalAcademy.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/GS_Global_Academy/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "06/14/2025",
  },
  {
    title: "Seminar on Scholarship for Abroad Education",
    img: Scholarship_for_Abroad_Education.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/SCHOLARSHIP_FOR_ABROAD_EDUCATION/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "11/04/2025",
  },
  {
    title: "Vision International",
    img: VisionInternationalImg.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/VISION_INTERNATIONAL/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "10/12/2024",
  },
  {
    title: "Career Counselling Seminar",
    img: CareerCounsellingSeminarImg.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Study_Abroad/CAREER_COUNSELLING_SEMINAR/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "01/27/2025",
  },
];

const campusInterviewsEvents: Array<CurricularEventObject> = [
  {
    title: "Physioactive Clinic",
    img: PhysioactiveClinicImg.images.map((image) => ({
      src: require(`../../assets/images/student_corner/Campus_Interviews/PHYSIOACTIVE_CLINIC/${image.src.split("/").pop()}`),
      alt: image.title,
      type: "image",
    })),
    date: "01/30/2025",
  },
];

const placementCellAnnualReports: Array<CurricularEventObject> = [
  {
    title: "Placement Cell Annual Report 2024",
    img: [
      {
        src: require("../../assets/pdfs/students/placement_reports/Placement cell activity 2024-25.pdf"),
        alt: "Placement Report 2024",
        type: "pdf",
      },
    ],
  },
];

// ---------------- COMPONENT ----------------

const RenderEvent = ({ data }: EventsProps) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <Grid container spacing={2}>
      {data?.map((item: CurricularEventObject, index: number) => {
        const isMultiImages = Array.isArray(item?.img) && item?.img?.length > 1;
        const firstItem = item?.img?.[0];
        const isPDF = firstItem?.type === "pdf";
        const imageToShow = (firstItem?.src ?? "") as string;

        return (
          <Grid
            key={index}
            item
            xs={12}
            sm={6}
            p={2}
            margin={"auto"}
            flexWrap={"wrap"}
            sx={{
              minWidth: {
                xs: "100%",
                sm: "48%",
              },
              maxWidth: {
                xs: "100%",
                sm: "48%",
              },
            }}
          >
            <Card
              sx={{
                alignContent: "space-between",
                minWidth: "100%",
                maxWidth: "100%",
                minHeight: "400px",
                maxHeight: "400px",
                position: "relative",
              }}
            >
              <>
                {/* ---------------- PDF CARD ---------------- */}
                {isPDF ? (
                  <Box
                    sx={{
                      height: "240px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#f5f5f5",
                    }}
                  >
                    <PictureAsPdf sx={{ fontSize: "5rem", color: "gray" }} />
                    <Typography variant="subtitle1" sx={{ mt: 1 }}>
                      {firstItem?.alt}
                    </Typography>
                    <Button
                      variant="contained"
                      sx={{ mt: 2, color: "white" }}
                      onClick={() => window.open(firstItem?.src, "_blank")}
                    >
                      View PDF
                    </Button>
                  </Box>
                ) : (
                  <>
                    {/* ---------------- IMAGE LOGIC (UNCHANGED) ---------------- */}
                    {isMultiImages ? (
                      <Box sx={{ position: "relative" }}>
                        <ImageSlideshow
                          sx={{}}
                          images={item?.img as Array<ImageType>}
                          showCaption={false}
                        />
                        <Box
                          sx={{
                            position: "absolute" as "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                          onClick={() => {
                            setTitle(item?.title ?? "");
                            setSliderImages(item?.img);
                            setOpen(true);
                          }}
                        >
                          <ZoomInRounded
                            sx={{
                              color: "#fdd025",
                              zIndex: 99,
                              fontSize: "4rem",
                              "&:hover": {
                                fontSize: "6rem",
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    ) : (
                      <Box sx={{ position: "relative" }}>
                        <CardMedia
                          component="img"
                          height="240px"
                          sx={{
                            pt: 1,
                            margin: "auto",
                            objectFit: "cover",
                          }}
                          image={imageToShow}
                          alt={item?.title as string}
                        />
                        <Box
                          sx={{
                            position: "absolute" as "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                          }}
                          onClick={() => {
                            setTitle(item?.title ?? "");
                            setSliderImages(item?.img);
                            setOpen(true);
                          }}
                        >
                          <ZoomInRounded
                            sx={{
                              color: "#fdd025",
                              zIndex: 2,
                              fontSize: "4rem",
                              "&:hover": {
                                fontSize: "6rem",
                              },
                            }}
                          />
                        </Box>
                      </Box>
                    )}
                  </>
                )}
                <Divider sx={{ py: 1 }} />
              </>

              <CardContent>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: "bold",
                      color: theme.palette.primary.contrastText,
                      padding: "10px",
                    }}
                  >
                    {item?.title}
                  </Typography>
                  {item?.description && (
                    <Typography
                      variant="subtitle1"
                      sx={{
                        textAlign: "left",
                        fontWeight: "bold",
                        fontSize: "1rem",
                        color: theme.palette.grey[900],
                        p: 2,
                      }}
                    >
                      {item?.description}
                    </Typography>
                  )}
                </Box>
              </CardContent>

              {item.date &&
                <Typography
                  sx={{
                    color: "white",
                    position: "absolute",
                    top: 16,
                    fontWeight: "bold",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  {formatDate(item?.date as string)}
                </Typography>
              }
            </Card>
          </Grid>
        );
      })}

      {data?.length === 0 && <Box sx={{ p: 4 }}>No Data</Box>}

      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={
            <Grid item xs={12} margin={"auto"}>
              <Box sx={{ width: "75%", margin: "auto" }}>
                <ImageSlider images={sliderImages} />
              </Box>
            </Grid>
          }
        />
      )}
    </Grid>
  );
};

// ---------------- UTIL ----------------

const formatDate = (dateString: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

// ---------------- MAIN COMPONENT ----------------

const Placement = () => {
  const [title, setTitle] = useState("Campus Interviews");

  const YearTabs = () => (
    <Grid container spacing={2}>
      {years?.map((item) => (
        <Grid item key={item?.title} xs="auto" sx={{ my: { sm: 1, md: 4 } }}>
          <Chip
            label={item?.title}
            variant="filled"
            sx={{
              color: item?.title === title ? "secondary.main" : "white",
              backgroundColor:
                item?.title === title ? "transparent" : "secondary.main",
              cursor: "pointer",
              border: "2px solid",
              padding: "8px 16px",
              borderRadius: "16px",
              textTransform: "uppercase",
              fontWeight: "bold",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                opacity: 0.8,
                color: "inherit",
                backgroundColor: "transparent",
                border: "2px solid",
                borderColor: "secondary.main",
                "& .MuiChip-label": {
                  textDecoration: "underline",
                },
              },
              "&:active": {
                transform: "scale(0.95)",
              },
            }}
            onClick={() => setTitle(item?.title ?? "")}
          />
        </Grid>
      ))}
    </Grid>
  );

  const filteredEvents =
    title === "Campus Interviews"
      ? campusInterviewsEvents
      : title === "Placement Cell Annual Reports"
        ? placementCellAnnualReports
        : studyAbroadEvents;

  return (
    <Box
      sx={{
        backgroundColor: "primary.light",
        p: { xs: 1, md: 3 },
        width: "90%",
        margin: "auto",
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ border: "1px solid #e0e0e0", p: { xs: 1, md: 3 } }}
      >
        <Typography
          fontSize={16}
          sx={{ textIndent: 32, m: 1, mt: { xs: 3, md: 1 } }}
        >
          The Placement Cell at PES Modern College of Physiotherapy is dedicated
          to bridging the gap between academia and the professional world. Our
          primary objective is to facilitate the successful transition of our
          students into rewarding careers. The cell plays a pivotal role in
          guiding students towards their desired career paths, providing
          comprehensive support and resources.
        </Typography>
        <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
          The placement cell actively engages in building strong industry
          relationships, identifying potential employers, and creating ample
          opportunities for students. We organize career counselling sessions,
          workshops, and seminars to equip students with essential soft skills,
          communication skills, and interview techniques. Mock interviews are
          conducted to boost students’ confidence and prepare them for
          real-world challenges.
        </Typography>
        <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
          The cell maintains an up-to-date database of students, their academic
          performance, and career aspirations. This information is shared with
          prospective employers to match suitable candidates with appropriate
          job profiles. We organize on-campus recruitment drives, inviting a
          diverse range of healthcare organizations to conduct interviews and
          select eligible students.
        </Typography>
        <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
          Beyond placements, the cell provides continuous support to students in
          exploring higher education options, such as master’s programs or
          doctoral studies. We offer guidance on entrance exams, application
          processes, and potential research areas. Our aim is to empower
          students to make informed decisions about their future career paths.
        </Typography>
        <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
          The placement cell also functions as a bridge between alumni and the
          college. We organize alumni interactions, mentorship programs, and
          networking events to provide current students with valuable insights
          and industry perspectives. By fostering strong alumni connections, we
          create a supportive network for our graduates.
        </Typography>
        <Typography fontSize={16} sx={{ textIndent: 32, m: 1 }}>
          The placement cell at Modern College of Physiotherapy is committed to
          the overall success of our students. We strive to create a conducive
          environment that empowers them to achieve their career goals and make
          significant contributions to the field of physiotherapy.
        </Typography>

        <YearTabs />
        <RenderEvent data={filteredEvents} />
      </Stack>
    </Box>
  );
};

export default Placement;
